<template>
  <div>
    <el-form>
      <el-form-item>
        <p  v-model="to_orderNumber">{{"运单编号:    " +this.to_orderNumber}}</p>
        <p v-model="to_account" >{{"客 户 号:   "+this.to_account}}</p>
      </el-form-item>
      <el-form-item>
        物品图片
        <upload_picture style="width:30%" :img-src="to_picture" @value="uploadData">{{this.to_picture}}</upload_picture>
      </el-form-item>
      <el-form-item>
        订单状态
        <el-select class="form-control" style="width: 200px ;margin-right: 20px" v-model="to_state">
          <el-option  v-for="item in options" :key="item.value" :label="item.label" :value="item.value"  >{{item.label,item.value}}</el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        备注
        <textarea style="width: 300px;height: 100px" v-model="to_remark"></textarea>
      </el-form-item>
      <el-button @click="updateUserOrder">保存</el-button>
      <el-button @click="back">返回</el-button>
    </el-form>
  </div>
</template>

<script>
  import upload_picture from "../../../components/upload/upload_picture";
  export default {
    components: {
      upload_picture
    },
    data() {
      return {
        options:[
          {label:'请选择',value:null},
          {label:'未发货',value:0},
          {label:'已发货',value:1},
          {label:'已收货',value:2}
        ],
        to_orderNumber:'',
        to_account:'',
        to_picture:'',
        to_state:'',
        to_remark:'',
      }
    },
    mounted() {
      this.to_orderNumber = this.$route.query.to_orderNumber
      this.to_account = this.$route.query.to_account
      this.to_picture = this.$route.query.to_picture
      this.to_remark = this.$route.query.to_remark
    },
    methods: {
      back(){
        this.$router.replace({
          path:'/UserRecord',
          query:{
            ta_account:this.to_account
          }
        })
      },
      uploadData(msg) {
        this.to_picture= msg
      },
      updateUserOrder(){
        this.$inbound.post({
          interfaceId: 'order/updateOrder',
          data: {
            to_state:this.to_state,
            to_orderNumber: this.to_orderNumber,
            to_picture:this.to_picture,
            to_remark:this.to_remark,
          }
        }).then(response => {
          this.$router.replace({
            path:'UserRecord',
            query:{
              ta_account:this.$route.query.to_account
            }
          })
        }).catch(error => {
          console.log(error)
        })
      }
    }
  }
</script>

<style>

</style>
